var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"common-button-help",attrs:{"src":_vm.$icons.Common.Help1,"alt":"help-button"}})}
var staticRenderFns = []

export { render, staticRenderFns }